import { render } from "./DefaultFieldset.vue?vue&type=template&id=917e7d98"
import script from "./DefaultFieldset.vue?vue&type=script&lang=js"
export * from "./DefaultFieldset.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__